import { useEffect, useRef, useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg, fileUrl, fmtBytes } from "@/lib/api";

export function useZip(wid) {
  const [job, setJob] = useState(null);
  const timer = useRef();
  useEffect(() => () => clearInterval(timer.current), []);
  const start = async (scope, ids) => {
    try {
      const r = await api.post(`/manage/weddings/${wid}/zip`, { scope, ids });
      setJob(r.data);
      clearInterval(timer.current);
      timer.current = setInterval(async () => {
        const s = await api.get(`/manage/weddings/${wid}/zip/${r.data.id}`);
        setJob(s.data);
        if (s.data.status !== "v_pripravi") clearInterval(timer.current);
      }, 1500);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return { job, start, close: () => { clearInterval(timer.current); setJob(null); } };
}

export function ZipDialog({ job, onClose }) {
  const pct = job ? Math.round((job.done / Math.max(job.total, 1)) * 100) : 0;
  return (
    <Dialog open={!!job} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#FFFDF9]" data-testid="zip-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Priprava ZIP arhiva</DialogTitle>
          <DialogDescription>{job?.total} datotek · {fmtBytes(job?.size)}</DialogDescription>
        </DialogHeader>
        {job?.status === "v_pripravi" && (
          <div className="space-y-3" data-testid="zip-progress">
            <div className="h-2 rounded-full bg-[#EADBCE] overflow-hidden"><div className="h-full bg-[#C5A880] transition-[width]" style={{ width: `${pct}%` }} /></div>
            <p className="text-sm text-[#6C6560] flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Pripravljamo {job.done} od {job.total} datotek … To okno lahko pustite odprto.</p>
          </div>
        )}
        {job?.status === "pripravljeno" && (
          <div className="space-y-3">
            <a href={fileUrl(job.download_url)} className="btn-dark h-12 flex items-center justify-center gap-2" data-testid="zip-download-link"><Download size={18} /> Prenesi ZIP</a>
            <p className="text-xs text-[#968E87]">Varna povezava je veljavna 24 ur.</p>
          </div>
        )}
        {job?.status === "napaka" && <p className="text-sm text-red-700">Priprava arhiva ni uspela. Poskusite znova.</p>}
      </DialogContent>
    </Dialog>
  );
}
